import api from 'api'

export type CushionChargePolicy = {
  id: number
  companyId: number
  chargeAfterMinutes: number
  startsAt: string
  endsAt: string | null
  createdAt: string
  updatedAt: string
}

export type ListCushionChargePoliciesResponse = {
  items: CushionChargePolicy[]
}

export const listCushionChargePolicies = async (
  companyId: number
): Promise<ListCushionChargePoliciesResponse> => {
  const response = await api.get<ListCushionChargePoliciesResponse>(
    `/admin/company/${companyId}/cushion_charge_policies`
  )
  return response.data
}
